/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unscramble letters into words. Free word finder and anagram solver for Scrabble, Words With Friends and word games. No signup.`)
};

const es_wu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte letras en palabras. Buscador de palabras y solucionador de anagramas gratuito para Scrabble, Words With Friends y otros juegos de palabras. Sin registro.`)
};

const de_wu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchstaben zu Wörtern entwirren. Kostenloser Wortfinder und Anagramm-Löser für Scrabble, Words With Friends und Wortspiele. Keine Anmeldung nötig.`)
};

const nl_wu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontwar letters tot woorden. Gratis woordzoeker en anagramoplosser voor Scrabble, Words With Friends en woordspellen. Geen registratie nodig.`)
};

const fr_wu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transformez des lettres mélangées en mots. Chercheur de mots et solveur d'anagrammes gratuit pour Scrabble, Words With Friends et les jeux de mots. Sans inscription.`)
};

const it_wu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocca le lettere e trasformale in parole. Cercatore di parole e risolutore di anagrammi gratuito per Scrabble, Words With Friends e giochi di parole. Nessuna registrazione.`)
};

const pt_br2_wu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desembaralhe letras e transforme-as em palavras. Localizador de palavras e solucionador de anagramas gratuito para Scrabble, Words With Friends e jogos de palavras. Sem necessidade de cadastro.`)
};

const pt_wu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbaralhe letras e transforme-as em palavras. Localizador de palavras e resolvedor de anagramas gratuito para Scrabble, Words With Friends e jogos de palavras. Sem registo.`)
};

const ja_wu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字を並べ替えて単語にします。Scrabble や Words With Friends などのワードゲームに使える、無料の単語検索・アナグラムソルバーです。登録不要。`)
};

const zh_wu_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将打乱的字母重组为单词。适用于 Scrabble、Words With Friends 等文字游戏的免费单词查找与易位构词求解工具，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_tool_description", locale)
	if (locale === "en") return en_wu_tool_description(inputs)
	if (locale === "es") return es_wu_tool_description(inputs)
	if (locale === "de") return de_wu_tool_description(inputs)
	if (locale === "nl") return nl_wu_tool_description(inputs)
	if (locale === "fr") return fr_wu_tool_description(inputs)
	if (locale === "it") return it_wu_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_wu_tool_description(inputs)
	if (locale === "pt") return pt_wu_tool_description(inputs)
	if (locale === "ja") return ja_wu_tool_description(inputs)
	return zh_wu_tool_description(inputs)
};